module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "titlepage"
    }
  }, [_c('p', {
    staticClass: "booktitle"
  }, [_c('span', {
    staticClass: "red"
  }, [_vm._v("SLOW FIRE")])]), _vm._v(" "), _c('p', {
    staticClass: "subtitle"
  }, [_vm._v("THE BEGINNER’S GUIDE TO BARBECUE")]), _vm._v(" "), _c('p', {
    staticClass: "author"
  }, [_c('span', {
    staticClass: "red"
  }, [_vm._v("BY RAY “DR. BBQ” LAMPE")])]), _vm._v(" "), _c('p', {
    staticClass: "othertext"
  }, [_vm._v("FOREWORD BY FAMOUS DAVE ANDERSON"), _c('br'), _vm._v("PHOTOGRAPHS BY LEIGH BEISCH")]), _vm._v(" "), _c('p', {
    staticClass: "publogo"
  }, [_c('img', {
    attrs: {
      "alt": "publisher logo",
      "src": "images/logo.jpg"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ac32e732","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/002titlepage.vue
// module id = 60
// module chunks = 0